export const formatNumber = (number = 0) => {
  return Number(number)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

export const formatPriceTR = (price) =>
  price.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  });

/**
 *
 * @param { Number } number
 * @param { String } locale
 * @returns { String } formatted number
 */
export const formatNumberBasic = (number = 0, locale = 'tr-TR') => {
  if (!number) return '0';

  return number.toLocaleString(locale);
};
